import {
    Button,
    Center
} from "@mantine/core";
import {
    FlexiCancelButton,
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import {useCookieConsent} from "../hooks/useCookieConsent.ts";


export const CookiePreferencesPage = () => {

    const {handleShowPreferences} = useCookieConsent()

    const navigate = useNavigate();

    return (
        <>
            <FormPageLayout
                title={'Manage Cookie Preferences'}
                tools={[<FlexiCancelButton onClick={() => navigate('/account')}/>]}>

                <SimplePageContentWrapper>
                    <Center my={'xl'}>
                        <Button onClick={handleShowPreferences}>Manage Cookie Preferences</Button>
                    </Center>
                </SimplePageContentWrapper>

            </FormPageLayout>
        </>
    );
};
